/**
 * Zod input schemas: mutations. Split out of the one big schemas.ts (Oct 2026) so a session opens only the tool it
 * works on; nothing changed in the schemas themselves. Import as before, from '@daaily/shared' (or './schemas.js'
 * inside shared); the barrel re-exports every file in this folder. Shared primitives (EmailSchema, MonthSchema, …)
 * live in primitives.ts; cross-tool references are explicit imports between these files.
 */
import { z } from 'zod';
import { DriverMonthKeySchema } from './drivers.js';
// ── Monthly Mutations (admin-only HR checklist) ──
export const MutationSaveSchema = z.object({
    /** Present = edit an existing entry; null/absent = create (the Firebase
     *  callable serializer sends an undefined `id` as null, so accept both). */
    id: z.string().min(1).nullish(),
    month: DriverMonthKeySchema,
    area: z.string().trim().min(1).max(120),
    category: z.string().trim().min(1).max(120),
    userEmail: z.string().trim().toLowerCase().email(),
    notes: z.string().trim().min(1, 'Add a note.').max(4000),
});
export const MutationSetStatusSchema = z.object({
    id: z.string().min(1),
    status: z.enum(['open', 'done']),
});
export const MutationDeleteSchema = z.object({ id: z.string().min(1) });
export const MutationsPdfPreviewSchema = z.object({
    month: DriverMonthKeySchema,
    area: z.string().trim().min(1).max(120),
});
// ── Commissions ──
//# sourceMappingURL=mutations.js.map